export default "__VITE_ASSET__$VFh22WU__"